export const FallbackComponent = ({ error }: { error: Error }) => {
  return (
    <div role="alert" style={{ padding: 40 }}>
      <h1>Something went wrong!</h1>
      <pre>{error.message}</pre>
    </div>
  );
};
